import { toast } from "react-toastify";

export default async function sendData(bearerToken, apiUrl, method, data, doMessageHandling = true) {
    let headers = new Headers();

    headers.set("Content-Type", "application/json" );
    headers.set("Authorization", `Bearer ${bearerToken}`);

    const requestParams = {
        method: method,
        headers: headers,
        body: JSON.stringify(data)
    }

    let action = getAction(method);
    return new Promise(async (resolve, reject) => {
        let response;

        try {
            response = await fetch(apiUrl, requestParams);
            if (!(response.status >= 200 && response.status < 500)) {
                reject(`Request to [...] failed - ${response.status}: ${response.statusText}`);
            } else {
                if (response.status === 200 && doMessageHandling) {
                    toast.success(`${action} success.`);
                }
                else if (response.status === 401) {
                    response.message = "You are not authorized.";
                    if (doMessageHandling){
                        toast.error("You are not authorized.");
                    }
                }
                else if (response.status === 403) {
                    response.message = `You have no permission to ${action} this information.`;
                    if (doMessageHandling) {
                        toast.error(response.message);
                    }
                }
                resolve(response);
            }
        } catch (e) {
            reject(e);
        }
        resolve(response);
    });
}

function getAction(method){
    switch(method.toUpperCase()) {
        case 'POST':
            return 'create';
        case 'DELETE':
            return 'delete'
        case 'PATCH':
        case 'PUT':
            return 'update'
        default:
            return 'create, update or delete';
    }
}